<script setup>
    import { ref } from 'vue';

    const props = defineProps({
        selectedSort: {
            type: String
        }
    });

    const currentSort = ref({
        key: 'NEWEST',
        value: 'Nyeste'
    });

    const sortOptions = [
        { key: 'PRICE_LOW_HIGH', value: 'Pris - lav til høj' },
        { key: 'PRICE_HIGH_LOW', value: 'Pris - høj til lav' },
        { key: 'NEWEST', value: 'Nyeste' },
        { key: 'OLDEST', value: 'Ældste' },
        { key: 'NAME_A_Z', value: 'Navn - A til Å' },
        { key: 'NAME_Z_A', value: 'Navn - Å til A' },
    ];

    const emit = defineEmits(['sortingUpdated']);

    const changeSort = (sort, value) => {
        const foundSort = sortOptions.find(option => option.key === sort);

        // Update the current sort
        currentSort.value.key = foundSort.key;
        currentSort.value.value = foundSort.value;

        currentSort.value = foundSort;

        // Emit an event to the parent component with the new key
        emit('sortingUpdated', currentSort.value.key);
    };

    const sortValue = sortOptions.find(option => option.key === props.selectedSort);

</script>

<template>
    <div>
        <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                {{ sortValue.value }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li v-for="option in sortOptions" :key="option.key" @click="changeSort(option.key, option.value)" class="dropdown-item" :class="{ active: option.key === currentSort.value.key }">{{ option.value }}</li>
            </ul>
        </div>
    </div>
</template>

<style scoped>
    .dropdown {
        display: inline-block;
    }

    .dropdown-menu {
        
    }

    .dropdown-item {
        color: black;
        cursor: pointer;
    }

    .dropdown-item:hover {
        background-color: #6C757D;
        color: white;
    }
</style>